import { Spinner } from '@lensora/ui'
import { Navigate, Outlet } from 'react-router-dom'


import { useAuth } from '@/providers/auth-provider'

export function ProtectedLayout() {
  const auth = useAuth()

  if (auth.status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center bg-surface">
        <Spinner size="lg" />
      </div>
    )
  }

  if (auth.status === 'unauthenticated') {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
